import { render, staticRenderFns } from "./law-header.vue?vue&type=template&id=386fb57e&scoped=true"
import script from "./law-header.vue?vue&type=script&lang=js"
export * from "./law-header.vue?vue&type=script&lang=js"
import style0 from "./law-header.vue?vue&type=style&index=0&id=386fb57e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fb57e",
  null
  
)

export default component.exports